// 编写系统所有常量

let SysConstant = {
  DATE_FORMATE: 'yyyy-MM-dd',
  mustNumber: '请输入数字',
  success: '操作成功',
  fail: '操作失败',
  enable: 0, // 启用
  disable: 1, // 禁用
  basicAuth: 'Basic anR5YXBpOjljY2E4MjdjY2ZiOTRmYjhhYmYyZDI1NWJhOTczZmQw',
  winHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
}

export default SysConstant



// WEBPACK FOOTER //
// ./src/utils/sysconstant.js